import './pegasus/precompiled-templates.js'
import './pegasus/app.js'
import './pegasus/helpers.js'
import './pegasus/drag_manager.js'
import './pegasus/states.js'
import './pegasus/store.js'
import './pegasus/routes.js'
import './pegasus/models.js'
import './pegasus/computed.js'
import './pegasus/template_helpers.js'
import './pegasus/io_manager.js'
import './pegasus/command_manager.js'
import './pegasus/controllers.js'

import './pegasus/views.js'
import '~/pegasus/components/loading_spinner/component.js'
import '~/pegasus/components/text_field/component.js'
import '~/pegasus/components/text_field_with_limit/component.js'
import '~/pegasus/components/simple_spinner/component.js'
import '~/pegasus/components/textarea/component.js'

require('./pegasus/assets/stylesheets/editor.css.scss');

export default window.Pegasus;
